import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { parse, parseISO, format } from "date-fns";
import styles from "../../initial/layersPopup/Menu.module.css";

interface TimelineTimeRangePopupProps {
  passForm: (from: string) => void;
  passTo: (to: string) => void;
  showTimeRangeNotification: (show: boolean) => void;
  isAllFilterOpen: boolean;
  title: string;
}

const TimelineTimeRangePopup: React.FC<TimelineTimeRangePopupProps> = ({
  passForm,
  passTo,
  showTimeRangeNotification,
  isAllFilterOpen,
  title,
}) => {
  const [from, setFrom] = useState<string>("");
  const [timeRangeFrom, setTimeRangeFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [timeRangeTo, setTimeRangeTo] = useState<string>("");

  const formatDateString = (dateString: string): string => {
    const parsedDate = parseISO(dateString);
    const formattedDate = format(parsedDate, "EEE d MMM, yyyy");

    return formattedDate;
  };
  const checkDateRange = () => {
    if (from && to) {
      const fromCheck = new Date(from);
      const toCheck = new Date(to);

      const sixMonthsInMillis = 6 * 30 * 24 * 60 * 60 * 1000;

      if (
        Math.abs(toCheck.getTime() - fromCheck.getTime()) > sixMonthsInMillis
      ) {
        showTimeRangeNotification(true);
        //alert("The date range exceeds 6 months.");
      } else {
        passForm(timeRangeFrom);
        passTo(timeRangeTo);
      }
    } else {
      //alert("Please select both dates.");
      passForm(timeRangeFrom);
      passTo(timeRangeTo);
    }
  };

  return (
    <>
      <div
        className={styles.contentContainerTime}
        style={{ height: `${isAllFilterOpen ? "40px" : "0"}` }}
      >
        <div className={styles.dataContainer} style={{ gridArea: `a` }}>
          <div className={styles.inputContainer}>
            <label htmlFor={`${title}From`}>From</label>
            <input
              type="date"
              name=""
              id={`${title}From`}
              value={from}
              onChange={(event) => {
                setFrom(event.target.value);
                if (event.target.value === "") {
                  setTimeRangeFrom("");
               
                } else {
                  setTimeRangeFrom(formatDateString(event.target.value));
                }
              }}
            />
          </div>
        </div>
        <div className={styles.dataContainer} style={{ gridArea: `b` }}>
          <div className={styles.inputContainer}>
            <label htmlFor={`${title}To`}>To</label>
            <input
              type="date"
              name=""
              id={`${title}To`}
              value={to}
              onChange={(event) => {
                setTo(event.target.value);

                if (event.target.value === "") {
                  setTimeRangeTo("");
                } else {
                  setTimeRangeTo(formatDateString(event.target.value));
                }
              }}
            />
          </div>
        </div>
        <div className={styles.dataContainer} style={{ gridArea: `c` }}>
          <button onClick={checkDateRange} onTouchStart={checkDateRange}>Set</button>
        </div>
      </div>
    </>
  );
};

export default TimelineTimeRangePopup;
